/* eslint-disable */
import { useMemo } from 'react';
import { deriveSeasonOptions } from '../../../utils/devSeasonOptions';
import { SELECTION_SEASON, readSelectionAt } from '../../developments/SelectionChip';

// ============================================================
// useDevFilterOptions — the option lists of the Developments filter bar, with
// counts. Derived exactly as DevsActionBar derives them (distinct values from
// the full `devs` array + dev_settings.devFields options as a fallback;
// Convention #29 for the four shape keys; Convention #140 for Sun/Optic). The
// counts are the distinct-value frequencies over `devs` — what the filter
// popover shows beside each option.
// ============================================================

const sortAsc = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' });
const SUN_OPTIC = [{ value: 'sun', label: 'Sun' }, { value: 'optic', label: 'Optic' }];
export const DECISION_OPTS = [{ value: 'in', label: 'IN' }, { value: 'out', label: 'OUT' }];
export const PROCUREMENT_OPTS = [{ value: 'order', label: 'ORDER' }, { value: 'preorder', label: 'PRE-ORDER' }];
export const NO_SEASON = '_no_season';

function tally(map, v) { const k = (v ?? '').toString().trim(); if (k) map.set(k, (map.get(k) || 0) + 1); }
function toOpts(map, extra = []) {
  const keys = new Set([...map.keys(), ...extra.filter(Boolean)]);
  return Array.from(keys).sort(sortAsc).map((v) => ({ value: v, label: v, count: map.get(v) || 0 }));
}

export function useDevFilterOptions(devs, devSettings) {
  return useMemo(() => {
    const settingsOpts = (key) => { const f = (devSettings?.devFields || []).find((x) => x?.key === key); return Array.isArray(f?.options) ? f.options : []; };
    const designers = new Map(), factories = new Map(), materials = new Map(), shapes = new Map();
    let sun = 0, optic = 0, inN = 0, outN = 0, order = 0, pre = 0;
    for (const d of devs || []) {
      const dz = d?.data || {};
      tally(designers, d?.designer ?? dz.designer);
      tally(factories, d?.fty ?? dz.fty);
      tally(materials, d?.material ?? dz.material);
      const seen = new Set();
      ['shape', 'shape1', 'shape2', 'shape3'].forEach((k) => { [d?.[k], dz[k]].forEach((v) => { const t = (v ?? '').toString().trim(); if (t && !seen.has(t)) { seen.add(t); tally(shapes, t); } }); });
      const type = (d?.dev_type ?? dz.dev_type ?? '').toString().toUpperCase();
      if (type === 'DA' || type === 'DS') sun++; else if (type === 'DO') optic++;
      // The same tolerant read the chip and the filter use (matchesSelectionSets).
      const sel = d?.selections || dz.selections;
      const r = sel && typeof sel === 'object' && !Array.isArray(sel) ? readSelectionAt(sel[SELECTION_SEASON]) : null;
      if (r?.decision) { if (r.decision === 'out') outN++; else inN++; }
      if (r?.procurement === 'order') order++; else if (r?.procurement === 'preorder') pre++;
    }
    const seasonOpts = deriveSeasonOptions(devs);
    const seasonFreq = new Map();
    for (const d of devs || []) tally(seasonFreq, d?.season || d?.data?.season);
    const noSeason = (devs || []).filter((d) => !((d?.season || d?.data?.season || '').toString().trim())).length;
    return {
      sunOptic: SUN_OPTIC.map((o) => ({ ...o, count: o.value === 'sun' ? sun : optic })),
      designer: toOpts(designers, settingsOpts('designer')),
      factory: toOpts(factories, settingsOpts('fty')),
      material: toOpts(materials, settingsOpts('material')),
      shape: toOpts(shapes, settingsOpts('shape')),
      season: [...seasonOpts.map((o) => ({ ...o, count: seasonFreq.get(o.value) || 0 })), { value: NO_SEASON, label: 'No season', count: noSeason }],
      decision: DECISION_OPTS.map((o) => ({ ...o, count: o.value === 'in' ? inN : outN })),
      procurement: PROCUREMENT_OPTS.map((o) => ({ ...o, count: o.value === 'order' ? order : pre })),
    };
  }, [devs, devSettings]);
}
